import React from "react";

/**
 * "What is this list?" asked before an import is saved. The file alone can't
 * say whether these people are buyers or landlords, and a landlord list saved
 * as buyers is how landlords were sent buyer-portal invites (27 Oct 2026). The
 * answer sets the contact type of everyone the import creates.
 */
export default function ListKindPicker({ options = [], value, onChange, label = "What is this list?", name = "list-kind" }) {
  if (!options.length) return null;
  return (
    <fieldset className="rounded-lg border border-gray-200 p-3">
      <legend className="px-1 text-xs font-extrabold uppercase tracking-wide text-gray-500">{label}</legend>
      <div className="flex flex-wrap gap-2">
        {options.map((o) => (
          <label
            key={o.key}
            className={`cursor-pointer rounded-full border px-3 py-1 text-sm ${value === o.key ? "border-[#55c5d0] bg-[#f4fbfc] text-[#0e7d86] font-semibold" : "border-gray-200 text-gray-700 hover:bg-gray-50"}`}
          >
            <input
              type="radio" name={name} value={o.key} checked={value === o.key}
              onChange={() => onChange(o.key)} className="sr-only"
            />
            {o.label}
          </label>
        ))}
      </div>
      {!value && <p className="mt-2 text-xs text-gray-500">Pick one to continue.</p>}
    </fieldset>
  );
}
